import React from 'react'

import facebookLogo from '../img/facebook30x30.png'
import instagramLogo from '../img/instagram30x30.png'

const Footer = (props) => {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <p>Copyright &copy; TK Vamos 2017</p>
                        <div className="social-icons">
                            <a className="footer-right"  target="_blank" title="follow me on facebook" href="https://www.facebook.com/tkvamoszg/">
                                <img src={facebookLogo} alt=""/>
                            </a>
                            <a className="footer-left" target="_blank" title="follow me on instagram" href="http://www.instagram.com/teniski_klub_vamos">
                                <img src={instagramLogo} alt=""/>
                            </a>
                        </div> 
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js